import { Grid } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';
import ReservationRequestContent from '../../components/Reservations/ReservationRequest/ReservationRequestContent';
import {
    useGetIndividualAssetQuery,
    useGetOwnerExperienceQuery,
} from '../../../app/Slices/SevenDayApiSlice';
import React, { useEffect } from 'react';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import UserRole from '../../../shared/AuthRoles';

const OwnerReservationRequest = ({ id }: { id: number }) => {
    const loggedInUser = UserRole();

    const { data, isLoading, isError } = useGetOwnerExperienceQuery({
        owner: loggedInUser?.company,
        experience: id,
    });

    if (isLoading)
        return (
            <Grid
                sx={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <LoadingComponent />
            </Grid>
        );
    if (isError) return <Navigate to='/*' replace />;

    return <ReservationRequestContent reservationDetails={data} />;
};

const GuestReservationRequest = ({ id }: { id: number }) => {
    const { data, isLoading, isError } = useGetIndividualAssetQuery(
        `modules/${id}`,
    );

    if (isLoading)
        return (
            <Grid
                sx={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <LoadingComponent />
            </Grid>
        );
    if (isError) return <Navigate to='/*' replace />;

    return <ReservationRequestContent reservationDetails={data} />;
};

const ReservationRequestPage = () => {
    const { moduleId } = useParams();

    const loggedInUser = UserRole();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!moduleId) return <Navigate to='/*' replace />;

    return loggedInUser?.role.includes('owner') ? (
        <OwnerReservationRequest id={+moduleId} />
    ) : (
        <GuestReservationRequest id={+moduleId} />
    );
};

export default ReservationRequestPage;
